module.exports = __webpack_public_path__ + "img/cases-brand-8-cover.9c44de4f.png";